import React from 'react'
import { FaArrowRight, FaStar } from 'react-icons/fa'
function CC_Review_Program_Page() {
  return (
    <div>
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center review_component_text'>
                <h1 className='display-5 pb-1'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp'>
                    <div className='mt-5 px-5 review_component_text'>
                        <h1 className='pt-5 display-6'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Ujjwal Ananda Maity</h5>
                    <h6 class="font-weight-bold my-2">Ismail Yusuf College</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>excellent guidance and support to the student's skill development sessions were best i have learned  the best interview cracking skills here 
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Satyabrat Sahoo</h5>
                    <h6 class="font-weight-bold my-2">ITER,SOA university, CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>My cloud computing internship provided hands-on experience in hosting websites and API integration, enhancing my skills and project management abilities. Grateful for mentorship and well-prepared for the dynamic field. Thankyou Internselite team for great opportunity. 
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Anisha Ashok Takalkar</h5>
                    <h6 class="font-weight-bold my-2">Late. T.D Pathare College, BSC (Computer Science)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>It's Just feeling Amaze with doing study online classes with Internselite and have chance to gain and improve my  knowledge through out the class was very supportive and active at the time of meeting... Overall good 
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Aditya Kumar</h5>
                    <h6 class="font-weight-bold my-2">Noida International University, (BCA)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>The experience was really good with internselite. The mentors was really well experienced and explain each and every topic very well and always clears clears our doubt. And asks questions also and give one on one attention 
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Soumya Ranjan Patra</h5>
                    <h6 class="font-weight-bold my-2">ITER,SOA University, CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>I am immensely grateful for Internselite's project-based approach, allowing me to translate theoretical knowledge into tangible achievements. This experience not only deepened my understanding but also instilled a strong sense of accomplishment in applying skills to real-world projects.
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Pankaj Kumar Dubey</h5>
                    <h6 class="font-weight-bold my-2">IPS Academy, Indore</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Really brilliant course, thank you very much. Very informative. this is going to really help and the checklist is going to be an absolute bonus. So, really impressive. Thank you very much, I have really enjoyed it.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default CC_Review_Program_Page
